export default "__VITE_ASSET__rWvlwpol__"